import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import { MdEmail, MdPhone, MdLocationOn } from "react-icons/md";

const Footer = () => {
  return (
    <footer
      className="text-white pt-16 pb-10 px-6 md:px-20 relative"
      style={{
        background: "linear-gradient(135deg, #0a2545 0%, #0d5e63 100%)",
      }}
    >
      {/* Top Section */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10 border-b border-teal-400/30 pb-10">
        {/* Logo + Tagline */}
        <div>
          <h2 className="text-3xl font-extrabold text-teal-400 mb-3 tracking-wide">
            Yes <span className="text-white">Auto</span>
          </h2>
          <p className="text-gray-300 text-sm leading-relaxed">
            Your trusted Canadian car financing partner — connecting you to
            affordable solutions with premium service.
          </p>
        </div>

       {/* Quick Links */}
<div>
  <h3 className="text-xl font-semibold mb-4 text-teal-300">
    Quick Links
  </h3>

  <ul className="space-y-2 text-gray-300">

    <li>
      <Link to="/" className="hover:text-teal-400 transition-all">
        Home
      </Link>
    </li>

    <li>
      <Link to="/financing" className="hover:text-teal-400 transition-all">
        Financing
      </Link>
    </li>

    <li>
      <Link to="/about" className="hover:text-teal-400 transition-all">
        About
      </Link>
    </li>

    <li>
      <Link to="/contact" className="hover:text-teal-400 transition-all">
        Contact
      </Link>
    </li>

    <li>
      <Link to="/privacy-policy" className="hover:text-teal-400 transition-all">
        Privacy Policy
      </Link>
    </li>

  </ul>
</div>

        {/* Contact Info */}
        <div>
          <h3 className="text-xl font-semibold mb-4 text-teal-300">Contact</h3>
          <ul className="space-y-3 text-gray-300">
            <li className="flex items-center gap-3">
              <MdEmail className="text-teal-400 text-xl" />
              yesautofinance1@gmail.com
            </li>
            <li className="flex items-center gap-3">
              <MdPhone className="text-teal-400 text-xl" /> +1(587)920-6970
            </li>
            <li className="flex items-center gap-3">
              <MdLocationOn className="text-teal-400 text-xl" />
              Alberta, Canada
            </li>
          </ul>
        </div>

        {/* Social Media */}
        <div>
          <h3 className="text-xl font-semibold mb-4 text-teal-300">
            Follow Us
          </h3>
          <div className="flex space-x-4 text-2xl">
  <a
    href={process.env.REACT_APP_FACEBOOK || "#"}
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-teal-400 transition-all"
  >
    <FaFacebook />
  </a>
  <a
    href={process.env.REACT_APP_INSTAGRAM || "#"}
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-teal-400 transition-all"
  >
    <FaInstagram />
  </a>
  <a
    href={process.env.REACT_APP_LINKEDIN || "#"}
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-teal-400 transition-all"
  >
    <FaLinkedin />
  </a>
  <a
    href={process.env.REACT_APP_YOUTUBE || "#"}
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-teal-400 transition-all"
  >
    <FaYoutube />
  </a>
</div>

        </div>
      </div>

      {/* Bottom Line */}
      <div className="text-center mt-10 text-gray-400 text-sm border-t border-teal-400/20 pt-6">
        <p>© 2025 Yes Auto. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
